export default __webpack_public_path__ + "static/media/large.93a5d167.jpg";